import { createAction } from '@reduxjs/toolkit';

export const reset = createAction('RESET');

export const triggerMobileLogout = createAction(
  'TRIGGER_MOBILE_LOGOUT',
  function prepare(onSuccess?: () => void) {
    return {
      payload: {
        onSuccess,
      },
    };
  }
);
